export function isDefined(value: any) {
	return value !== null && value !== undefined;
}

export function isObject(value: any) {
	return isDefined(value) && typeof value === 'object';
}

export function isPromise(value: any) {
	return value instanceof Promise;
}

export function isFunction(value: any) {
	return value instanceof Function;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/libs/@ng-select/ng-select/value-utils.ts